import Service from "../Service";
const resource = "selectionlot/";

export default {

    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },

    uploadSap(obj, requestID) {
        return Service.post(resource + "pagination", obj, {
            params: { requestID: requestID },
        });
    }


};